import React, { useState } from "react";
import { Grid, ListItem, Typography } from '@material-ui/core';
import { Group } from '@mantine/core';
import { Auth } from 'aws-amplify';
import PersonIcon from '../../shared/icons/personIcon';
import {
  landingWelcome,
} from '../../shared/utils/textConstants';
import { Typography as Icon } from '../../shared/theme/styles.enum';
import { useStyles } from './landing.styles';
import Link from '../../components/link/link';
import ParticleBackground from '../../components/particleBackground/particleBackground';
import { useEffect } from 'react';
import * as Sentry from "@sentry/react";
import { useSnapshot } from 'valtio';
import { state } from '../../shared/store';
import { gql, useLazyQuery } from '@apollo/client';

const Landing = () => {
  const url = window.location.href;
  const subdomainRegExp = /(?:http[s]*:\/\/)*(.*?)\.(?=[^/]*\..{2,5})/i;
  const subdomain = url.match(subdomainRegExp)?.[1];
  const classes = useStyles();
  const snap = useSnapshot(state);

  useEffect(() => {
    try {
      const hostname = localStorage.getItem('hostname');
      if (hostname && process.env.REACT_APP_ENV !== 'local') {
        const path = `https://${hostname}.${
          window.location.host.split('.').slice(1).join('.') +
          window.location.pathname
          }`;
        if (window.location.href !== path) window.location.replace(path);
      }
    } catch (e) {
      Sentry.captureException(e)
      console.log(e);
    }
    // eslint-disable-next-line
  }, []);

  const getLogo = gql`
  query advisorFirmConfigLogo($advisorSubdomain:String){
    advisorFirmConfigNoAuth(advisorSubdomain:$advisorSubdomain){
      logo
    }
  }
  `;

  const getHeaderAndParagraph = gql`
  query advisorFirmConfigHeaderParagraph($advisorSubdomain:String){
    advisorFirmConfigNoAuth(advisorSubdomain:$advisorSubdomain){
      header,
      paragraph
    }
  }
  `;

   useEffect(()=>{
    getAdvisorLogo({variables:{
     advisorSubdomain: subdomain
   }}).catch(() => {})

   },[subdomain])

   useEffect(()=>{
    getAdvisorHeaderandParagraph({variables:{
     advisorSubdomain: subdomain
   }}).catch(() => {})

   },[subdomain])


    const[firmLogo,sfirmLogo] = useState("")
    const[header,sheader] = useState("")
    const[paragraph,sparagraph] = useState("")

    const [getAdvisorLogo,{data:advisorLogoData}]=useLazyQuery(getLogo, { errorPolicy: 'all', onError: () => {} })
    const [getAdvisorHeaderandParagraph,{data:advisorHeaderandParagraphData}]=useLazyQuery(getHeaderAndParagraph, { errorPolicy: 'all', onError: () => {} })

    useEffect(()=>{
      sfirmLogo(advisorLogoData?.advisorFirmConfigNoAuth?.logo)
     },[advisorLogoData])

     useEffect(()=>{
      sheader(advisorHeaderandParagraphData?.advisorFirmConfigNoAuth?.header)
      sparagraph(advisorHeaderandParagraphData?.advisorFirmConfigNoAuth?.paragraph)

      },[advisorHeaderandParagraphData])

     useEffect(()=>{
      const paragraphContainer = document.getElementById("paragraphContainer")
      if(paragraphContainer !== null && paragraph!== undefined){

        paragraphContainer.innerHTML=String(paragraph)
      }
    },[paragraph])

    useEffect(()=>{
      const headerContainer = document.getElementById("headerContainer")
      if(headerContainer !== null && header!== undefined){

        headerContainer.innerHTML=String(header)
      }
    },[header])

   const signInEvent = async () => {
    try {
      await Auth.federatedSignIn();
    } catch (e) {
      Sentry.captureException(e)
      console.log(e);
    }
  };

  return (
    <div className={classes.grid}>
      <ParticleBackground />
      <div className={classes.topSection}>
        <Grid container>
          <Grid container item md={12} lg={7} direction="column">
            <p
              className={classes.paragraph}
              dangerouslySetInnerHTML={{ __html: paragraph || "" }}
            />
          </Grid>
          <Grid container item md={12} lg={5} direction="column" className={classes.fullHeight}>
            <div className={classes.container}>
              {firmLogo && <img src={firmLogo} alt="" className={classes.logo} />}

              <Typography className={classes.title}>
                {landingWelcome("")}
              </Typography>
              <Group>
                <ListItem
                  className={classes.buttonStyle}
                  onClick={signInEvent}
                >
                  <PersonIcon
                    alt="person"
                    className={classes.iconButton}
                    size={Icon.BasicText}
                  />
                  <Typography className={classes.buttonText}>Log In</Typography>
                </ListItem>
                <Link
                  to="/selfApply"
                  className={classes.linkStyle}
                >
                  <Typography className={classes.buttonText}>
                    New Account
                  </Typography>
                </Link>
              </Group>
            </div>
          </Grid>
        </Grid>
      </div>
      <div className={classes.legal}>
        Copyright: &copy; 2023 IFI Network Inc. All rights reserved.
        <br /><br />
        The IFI&nbsp;product names and logo are trademarks of IFI&nbsp;Network Inc. All other trademarks, logos, marks, and brand names are the property of their respective owners — used with permission.
        <br /><br />
        <strong>IFI&nbsp;Network is not a bank.</strong> Customer funds are held in various custodial deposit accounts. Each customer authorizes the Custodian Bank, through IFI, to hold the customer's funds in such accounts, in a custodial capacity, in order to effectuate the customer's deposits to and withdrawals from the various bank products that the customer requests. The Custodian Bank does not establish bank terms, and does not provide advice to customers about bank products offered through ifinetwork.com. Northern Trust is the Custodian Bank.
      </div>
    </div>
  );
};

export default Landing;
